import pick from "lodash.pick";
import {getAction} from "@api/manage";
import {checkHasPer} from "@/utils/authFilter";
import {Modal} from "ant-design-vue";

export const PlatformFormMixins = {
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: ()=>{},
      required: false
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },subHeight:{
      type: Number,
      default: 272,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      height:document.documentElement.clientHeight,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        platformId: {
          rules: [
            { required: true, message: '请选择挂靠平台!'},
          ]
        },currentStatus:{
          rules: [
            { required: true, message: '请如实选择状态!'},
          ]
        }
      },
      url: {
        add: "/dm/dmDriverPlatform/add",
        edit:"/dm/dmDriverPlatform/edit"
      },
      //carList:[],
      platformList:[],
      userList:[],
      teamName:'',
      teamList:[],
      checkHasPer:checkHasPer,
      hasIdNumber:true
    }
  },
  computed: {
    formDisabled(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return true
        }
      }
      return false
    }
  },
  created () {

    this.getPlatformList();
    this.getUserList();
    this.getTeamList();
  },
  methods: {
    checkHasIdNumber(){
      getAction("/api/driverApi/checkHasIdNumber",{driverId:this.model.driverId}).then(res=>{
        this.hasIdNumber = res.result.hasNumber;
      })
    },
    add (record) {
      this.edit(record);
    },
    edit (record) {
      console.log(record)
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'platformId','driverId','remark','identificationNumber','teamId','leaderId','currentStatus','regTime'))
      });
      this.checkHasIdNumber();
    },
    //渲染流程表单数据
    showFlowData(){
      if(this.formBpm === true){
        let params = {id:this.formData.dataId};
        getAction(this.url.queryById,params).then((res)=>{
          if(res.success){
            this.edit (res.result);
          }
        });
      }
    },
    submitForm () {

      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          if(this.hasIdNumber){
            this.submitSure(values);
          }else{
            Modal.confirm({
              title: '提示',
              content: '未完善身份证号的信息可能会与其他信息冲突，建议先完善再操作',
              okText: '去完善',
              cancelText: '忽略',
              centered: true,
              onOk: () => {
                this.$refs.driverForm.showInfo(null, this.model.driverId,{s:'基本信息',leftTab:1,b:'返回挂靠平台详情'})
              },
              onCancel:() =>{
                this.submitSure(values)
              }
            });
          }
        }

      })

    },submitSure(values){
      const that = this;
      //that.confirmLoading = true;
      let formData = Object.assign(this.model, values);
      if(formData.identificationNumber){
        formData.identificationNumber =  formData.identificationNumber.trim();
      }
      that.$emit('getData',formData);
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'platformId','driverId','remark','identificationNumber','teamId','leaderId','currentStatus','regTime'))
    },
    getPlatformList(){
      var that =this;
      getAction("/dm/dmPlatform/queryAllList",{}).then((res)=>{
        if(res.success){
          let platformList = res.result;
          if(platformList){
            for(var k in platformList){
              that.platformList.push({
                text:platformList[k].platformName,
                value:platformList[k].id
              });
            }

          }
        }
      });
    },
    getUserList() {
      var that = this;
      getAction("/sys/user/queryUserList", {}).then((res) => {
        if (res.success) {
          let userList = res.result;
          if (userList) {
            for (var k in userList) {
              that.userList.push({
                text: userList[k].realname,
                value: userList[k].id
              });
            }

          }
        }
      });
    },
    getTeamList() {
      var that = this;
      getAction("/dm/dmCarTeam/queryTeamList", {}).then((res) => {
        if (res.success) {
          let teamList = res.result;
          if (teamList) {
            for (var k in teamList) {
              that.teamList.push({
                text: teamList[k].teamName,
                value: teamList[k].id
              });
            }

          }
        }
      });
    }
  }
}